import { z } from 'zod'
import { groupTagSchema } from './group-tag.schema'

export const updateGroupSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters').max(100).optional(),
  description: z.string().max(500).optional(),
  tag: groupTagSchema.nullable().optional(),
})

export type UpdateGroupDto = z.infer<typeof updateGroupSchema>
